export default __webpack_public_path__ + "static/images/3f20939f4a82e71a9c1b8d70c978673e.jpg";